module.exports = __webpack_public_path__ + "static/media/215bc21a.jpg";